import React from 'react';

import { PopoverPaper, Stack, styled } from '@mui/material';

import SearchField from '../../../SearchField';
import { IFormSelectSearchProps } from '../../types';

const WrapperStyled = styled(Stack)(({ theme }) => ({
  width: '100%',
  position: 'sticky',
  top: 0,
  background: theme.palette.neutral.main,
  zIndex: 1,
  padding: theme.spacing(1, 1, 0, 1),
}));

const FormSelectSearch = React.forwardRef<HTMLDivElement, IFormSelectSearchProps>(
  ({ search, onSearchChange, onSearchClear, children, ...props }, ref) => {
    const handleStopPropagation = React.useCallback((event: any) => {
      event.stopPropagation();
    }, []);

    return (
      <PopoverPaper {...props} ref={ref}>
        <WrapperStyled>
          <SearchField
            name="search"
            value={search}
            onChange={onSearchChange}
            onClear={onSearchClear}
            onKeyDown={handleStopPropagation}
            onClick={handleStopPropagation}
            autoFocus
            sx={{ width: '100%' }}
          />
        </WrapperStyled>

        {children}
      </PopoverPaper>
    );
  },
);

export default FormSelectSearch;
